import React from 'react'

export function getTextContent(children) {
	let text = ''

	React.Children.forEach(children, (child) => {
		if (typeof child === 'string' || typeof child === 'number') {
			text += child
		} else if (React.isValidElement(child) && !!child.props.node?.children) {
			text += getTextContent(child.props.node.children)
		}
	})

	return text
}
